module.exports = __webpack_public_path__ + "static/media/de.bcd6a97e.png";